.reset {
    cursor: pointer;
    font: inherit;
    color: inherit;
    background: none;
    border: none;
    text-align: inherit;
}
